<template>
    <div>
        <FeatureCard
            v-for="plan of localPlans"
            :key="plan.dynamicType"
            :plan="plan"
            :current-plan="localCurrentPlans[plan._id]"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import FeatureCard from "./FeatureCard.vue";
import _ from "lodash";

export default {
    name: "Features",
    components: {
        FeatureCard,
    },
    props: {
        siteId: {
            type: String,
            default: null,
        },
        sitePlans: {
            type: Array,
            default: () => [],
        },
        siteCurrentPlans: {
            type: Array,
            default: () => [],
        },
    },
    data: () => {
        return {
            localFeatures: [],
            localPlans: {},
            localCurrentPlans: {},
            subscriptionFeature: null,
        };
    },
    mounted() {
        this.initData(this.siteId);
    },
    methods: {
        ...mapActions({
            subscribePlan: "site/subscribePlan",
            unsubscribePlan: "site/unsubscribePlan",
            extraSubscription: "site/extraSubscription",
            getSiteFeatures: "site/getSiteFeatures",
        }),
        async initData(siteId) {
            let features = _.cloneDeep(this.features);
            let plans = _.cloneDeep(this.plans);
            let currentPlans = _.cloneDeep(this.currentPlans);
            if (siteId) {
                features = await this.getSiteFeatures(this.siteId);
                plans = this.sitePlans;
                currentPlans = this.siteCurrentPlans;
            }
            this.localFeatures = features;
            this.localCurrentPlans = currentPlans.reduce((acc, planAction) => {
                acc[planAction.planId] = planAction;
                return acc;
            }, {});
            this.localPlans = plans.filter((plan) => plan.type === "feature").filter((plan) => !plan.isDeleted);
        },
        subscriptionFeaturePlan() {
            this.subscribePlan({
                planId: this.subscriptionFeature._id,
                period: "monthly",
            }).then(() => {
                this.subscriptionFeature = null;
                this.$notification.success({
                    message: "Başarılı",
                    description: "Başarılı bir şekilde özelliğiniz aktif edildi.",
                });
            });
        },
    },
    computed: {
        ...mapState({
            features: (state) => state.site.features,
            plans: (state) => state.site.plans,
            currentPlans: (state) => state.site.currentPlans,
        }),
    },
    watch: {
        plans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        currentPlans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        features: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        sitePlans: {
            handler() {
                this.initData(this.siteId);
            },
            deep: true,
        },
        siteCurrentPlans: {
            handler() {
                this.initData(this.siteId);
            },
            deep: true,
        },
    },
};
</script>
